import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

export const demoSystemHandlers = [
  // ── System health ─────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/health`, () => {
    return HttpResponse.json({
      total_bots: 3,
      running: 1,
      stopped: 1,
      halted: 1,
      crashed: 0,
      system_halted: false,
      system_halt_reason: null,
      bots: [
        {
          bot_id: 1,
          bot_name: '[DEMO] Momentum RSI — BTC/USDT',
          runtime_state: 'running',
          halted: false,
          halt_reason: null,
          last_error: null,
          last_heartbeat_at: new Date().toISOString(),
        },
        {
          bot_id: 2,
          bot_name: '[DEMO] MACD Cross — ETH/USDT',
          runtime_state: 'stopped',
          halted: false,
          halt_reason: null,
          last_error: null,
          last_heartbeat_at: null,
        },
        {
          bot_id: 3,
          bot_name: '[DEMO] Breakout Grid — SOL/USDT',
          runtime_state: 'halted',
          halted: true,
          halt_reason: 'Daily loss limit exceeded: -2.3% (-$350.40)',
          last_error: null,
          last_heartbeat_at: new Date(Date.now() - 2 * 24 * 3600 * 1000).toISOString(),
        },
      ],
    });
  }),

  // ── System metrics ────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/metrics`, () => {
    return HttpResponse.json({
      total_bots: 3,
      active_bots: 1,
      halted_bots: 1,
      total_orders: 33,
      filled_orders: 30,
      cancelled_orders: 3,
      pending_orders: 0,
      total_fills: 30,
      total_equity: '47320.00',
      total_daily_pnl: '1248.50',
      total_open_positions: 4,
      total_exposure: '23570.00',
      total_events: 412,
      exchange_accounts: 1,
    });
  }),

  // ── Exchange health ───────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/exchanges/health`, () => {
    return HttpResponse.json({
      checked_at: new Date().toISOString(),
      exchanges: [
        {
          exchange: 'BINANCE',
          state: 'healthy',
          error_rate: 0,
          avg_latency_ms: 38.2,
          request_count: 847,
          consecutive_failures: 0,
          checked_at: new Date().toISOString(),
          last_success_at: new Date().toISOString(),
        },
      ],
    });
  }),

  // ── Data quality ──────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/data-quality`, () => {
    return HttpResponse.json({
      total_symbols: 3,
      healthy_count: 3,
      unhealthy_count: 0,
      checked_at: new Date().toISOString(),
      symbols: [
        {
          symbol: 'BTC/USDT',
          exchange: 'BINANCE',
          status: 'healthy',
          last_update: new Date().toISOString(),
        },
        {
          symbol: 'ETH/USDT',
          exchange: 'BINANCE',
          status: 'healthy',
          last_update: new Date().toISOString(),
        },
        {
          symbol: 'SOL/USDT',
          exchange: 'BINANCE',
          status: 'healthy',
          last_update: new Date().toISOString(),
        },
      ],
      ws_connections: [{ exchange: 'BINANCE', connected: true, reconnect_count: 0 }],
    });
  }),

  // ── System risk ───────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/risk`, () => {
    return HttpResponse.json({
      system_exposure_breached: false,
      system_daily_loss_breached: false,
      total_exposure: '23570.00',
      total_daily_pnl: '1248.50',
      total_open_positions: 4,
      halted_bots: 1,
      total_bots: 3,
      bots: [
        {
          bot_id: 1,
          bot_name: '[DEMO] Momentum RSI — BTC/USDT',
          exposure: '8150.00',
          daily_pnl: '890.40',
          circuit_breaker_level: 'L0',
          open_positions: 2,
        },
        {
          bot_id: 3,
          bot_name: '[DEMO] Breakout Grid — SOL/USDT',
          exposure: '5000.00',
          daily_pnl: '-312.40',
          circuit_breaker_level: 'L3',
          open_positions: 2,
        },
      ],
    });
  }),

  // ── Confirmation token (for bot resume) ───────────────────────────────────
  http.get(`${BASE}/api/v1/system/confirmation-token`, () => {
    return HttpResponse.json({
      token: 'demo-confirmation-token-abc123',
      scope: 'bot_resume',
      expires_at: new Date(Date.now() + 5 * 60 * 1000).toISOString(),
      ttl_seconds: 300,
    });
  }),

  // ── System halt — blocked in demo (OPERATOR role, not ADMIN) ──────────────
  http.post(`${BASE}/api/v1/system/halt`, () => {
    return HttpResponse.json(
      { detail: 'Demo mode: system halt requires ADMIN role' },
      { status: 403 },
    );
  }),

  // ── System resume — same ──────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/system/resume`, () => {
    return HttpResponse.json(
      { detail: 'Demo mode: system resume requires ADMIN role' },
      { status: 403 },
    );
  }),

  // ── Reconciliation ────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/system/reconciliation`, () => {
    return HttpResponse.json({
      status: 'clean',
      checked_at: new Date().toISOString(),
      bots: [
        { bot_id: 1, status: 'clean', discrepancies: 0 },
        { bot_id: 2, status: 'clean', discrepancies: 0 },
        { bot_id: 3, status: 'clean', discrepancies: 0 },
      ],
    });
  }),
];
